import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { Customer } from '../../../model/shared/user/user';

import SignaturePad from 'signature_pad/dist/signature_pad.js';

import * as $ from 'jquery';

@Component({
  selector: 'app-popup-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.css']
})
export class SignatureComponent implements OnInit {

  @ViewChild('#signHere')
  signHere: ElementRef

  @ViewChild('#signatureBox')
  signatureBox: ElementRef

  @ViewChild('#signature')
  signatureCanvas: ElementRef

  bShow = false;
  _bClear = false;
  _bSave = false;

  @Input('model') _model: Customer;

  signHereText = 'Sign Here';

  signaturePad: SignaturePad;

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  dismiss() {
    if (this._bClear) {
      $(this.signHere.nativeElement).text('');
      this._bClear = false;
    }
    if ($(this.signHere.nativeElement).css('display') === 'none') {
      $(this.signHere.nativeElement).css('display', 'block');
    }

    this.bShow = false;
  }

  onSet() {
    if (this.signaturePad.isEmpty()) {
      alert('Please sign');
    } else {
      $(this.signHere.nativeElement).text('');
      this._model.signature = this.signaturePad.toDataURL();
      this.signaturePad.off();
      this.signaturePad.clear();
      this.dismiss();
    }

  }

  show() {
    this.bShow = true;
    this.changeDetectorRef.detectChanges();
    const canvas = this.signatureCanvas.nativeElement;
    if (!this.signaturePad) {
      this.signaturePad = new SignaturePad(canvas, { backgroundColor: 'rgb(251, 251, 251)' });
    }
    const ratio = Math.max(window.devicePixelRatio || 1, 1) || 1;
    const signaturePad = this.signaturePad;
    signaturePad.on();

    const signature = this._model.signature;
    setTimeout(this.resizeCanvas.bind(this), 100);
    window.onresize = this.resizeCanvas.bind(this);
    $(this.signatureBox.nativeElement).mousedown(function () {
      $(this.signHere.nativeElement).css('display', 'none');
    });
  }

  onSignatureClear() {
    $(this.signHere.nativeElement).text(this.signHereText);
    $(this.signHere.nativeElement).css('display', 'block');
    this.signaturePad.clear();
  }

  resizeCanvas() {
    const canvas = this.signatureCanvas.nativeElement;
    const ratio = Math.max(window.devicePixelRatio || 1, 1) || 1;
    const signaturePad = this.signaturePad;
    const signature = this._model.signature;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);

    if (signature) {
      $(this.signHere.nativeElement).text('');
      signaturePad.fromDataURL(signature);
    } else {
      $(this.signHere.nativeElement).text(this.signHereText);
      signaturePad.clear();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/component/signature/signature.component.ts